import axios from "axios";
import { getTokenFromLS } from "../account/tokenUtils";
import { Configuration } from "../configuration/configuration";

const base =
	document.getElementsByTagName("base")[0].getAttribute("href") || "/";
export async function renewToken() {
	const refreshToken = localStorage.getItem("refreshToken");

	if (!refreshToken) {
		throw new Error("refresh token does not exist");
	}

	const config = new Configuration();

	const fd = new FormData();
	fd.append("refreshToken", refreshToken);

	const response = await axios.post(`${config.API_AUTH_URL}/refresh`, fd, {
		headers: {
			"Content-Type": "application/json",
		},
		params: {
			refreshToken,
		},
	});
	const token = response.data.result;
	if (token) {
		return [token, refreshToken];
	} else {
		throw new Error("Token is not valid");
	}
}
function isUnauthorizedError(error: any) {
	const status = error?.response?.status;
	return status === 499 || status === 499; // custom status code
}

export const axiosInstance = axios.create({
	headers: {
		Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
	},
});

let refreshingFunc: any;
axiosInstance.interceptors.response.use(
	(res) => res,
	async (error) => {
		const originalConfig = error.config;

		if (originalConfig.headers.MESF_Retries === 1) {
			localStorage.removeItem("token");
			localStorage.removeItem("refreshToken");
			window.location.href = `${base}logout?message=Session%20expired&redirectTo=${window.location.href}`;
			return Promise.reject(error);
		}

		const token = getTokenFromLS();

		if (!token || !isUnauthorizedError(error)) {
			return Promise.reject(error);
		}

		try {
			if (!refreshingFunc) refreshingFunc = renewToken();

			const [newToken, newRefreshToken] = await refreshingFunc;

			localStorage.setItem("token", newToken);
			localStorage.setItem("refreshToken", newRefreshToken);

			axiosInstance.defaults.headers.Authorization = `Bearer ${newToken}`;
			originalConfig.headers.Authorization = `Bearer ${newToken}`;
			originalConfig.headers.MESF_Retries = 1;

			try {
				return await axios.request(originalConfig);
			} catch (innerError) {
				if (isUnauthorizedError(innerError)) {
					return Promise.reject(innerError);
				}
				return Promise.reject(innerError);
			}
		} catch (err) {
			localStorage.removeItem("token");
			localStorage.removeItem("refreshToken");
			window.location.href = `${base}logout?message=Session%20expired&redirectTo=${window.location.href}`;
			return Promise.reject(err);
		} finally {
			refreshingFunc = undefined;
		}
	},
);
